module.exports = __webpack_public_path__ + "img/0.43d599ed.jpg";